// extracted by mini-css-extract-plugin
module.exports = {"formDialog":"form-submit-dialog-module--formDialog--2ovpd","formDialog__heading":"form-submit-dialog-module--formDialog__heading--38-Wu"};